function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2,0.5C1.172,0.5 0.5,1.172 0.5,2L0.5,30C0.5,30.828 1.172,31.5 2,31.5L30,31.5C30.828,31.5 31.5,30.828 31.5,30L31.5,9C31.5,8.602 31.342,8.221 31.061,7.939L24.061,0.939C23.779,0.658 23.398,0.5 23,0.5L2,0.5ZM20.5,3.5L20.5,10C20.5,10.828 19.828,11.5 19,11.5L7,11.5C6.172,11.5 5.5,10.828 5.5,10L5.5,3.5L3.5,3.5L3.5,28.5C3.5,28.5 28.5,28.5 28.5,28.5C28.5,28.5 28.5,9.621 28.5,9.621C28.5,9.621 22.379,3.5 22.379,3.5L20.5,3.5ZM17.5,3.5L8.5,3.5L8.5,8.5C8.5,8.5 17.5,8.5 17.5,8.5L17.5,3.5Z"
});
var SvgSave = function SvgSave(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef
  }, props), _ref2);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSave, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/save.f96706fd.svg";
export { ForwardRef as ReactComponent };